'use client';

import { useTranslations } from 'next-intl';
import VoucherCodeDisplay from './VoucherCodeDisplay';
import WatchButton from './WatchButton';

interface StreamingAccessCardProps {
    ticketAllocationId: string;
    name: string;
    screening?: {
        id: string;
        name: string;
        start_time: string;
        end_time: string;
        screening_type: 'ONLINE' | 'OFFLINE';
        streaming_url?: string | null;
    } | null;
    voucher: {
        url: string;
        code: string;
        expiresAt: string | null;
        firstAccessedAt: string | null;
    } | null;
}

export default function StreamingAccessCard({
    ticketAllocationId,
    name,
    screening,
    voucher,
}: StreamingAccessCardProps) {
    const t = useTranslations('Common');

    if (!voucher) return null;

    const displayName = screening?.name || name;

    // Format screening date
    let screeningInfo = '';
    if (screening?.start_time) {
        const screeningDate = new Date(screening.start_time);
        screeningInfo = screeningDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
        });
    }

    return (
        <div className="border border-white/50 p-6 flex flex-col gap-4">
            <div className="flex flex-col gap-2">
                <h5 className="text-white uppercase text-lg">{displayName}</h5>
                {screeningInfo && (
                    <p className="text-white/70 text-sm uppercase">{screeningInfo}</p>
                )}
            </div>

            {/* Actions */}
            <div className="flex justify-between flex-row-reverse items-start">
                <WatchButton
                    ticketAllocationId={ticketAllocationId}
                    cinesendVideoId={screening?.streaming_url || ''}
                    voucherCode={voucher}
                />
                <VoucherCodeDisplay code={voucher.code} />
            </div>
        </div>
    );
}
